module.exports = __webpack_public_path__ + "img/vuetify.9f485045.png";